import React, { useContext, useEffect } from "react";
import { MenuContext, PartnersContext } from "../../App";

function Partners() {
  
  const PartnersList = useContext(PartnersContext);
  const [isMenuClicked, setIsMenuClicked] = useContext(MenuContext);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
    setIsMenuClicked(!isMenuClicked);
  }, []);

  return (
    <div className="w-full py-2 md:py-10 gap-y-10 flex flex-col items-center justify-center">
      <div className="w-full p-5 md:p-14 flex text-center bg-black bg-opacity-20 justify-center items-center rounded-lg">
        <p className="text-4xl md:text-8xl animate__animated animate__zoomIn">
          “Pioneering solutions <br /> through <br /> collaborative innovation.”
        </p>
      </div>
      <div className="w-full text-2xl md:text-6xl font-semibold flex flex-col items-center justify-center text-cyan-600">
        <p>Our Partners</p>
        <div className="w-11/12 p-5 gap-5 flex flex-wrap justify-center items-center">
          {PartnersList.map((partners) => {
            return (
              <div key={partners.id} className="w-[200px] h-[128px] md:w-[300px] md:h-[158px] px-1 flex justify-center items-center shadow-lg shadow-black bg-slate-100 rounded-lg animate__animated animate__zoomIn">
                <img src={partners.img} alt="AWS" className="w-full h-full object-contain"/>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}

export default Partners;
